/**
 * @ngdoc service
 * @name common.wishlist.service:ItxWishlistSvc
 * @requires $q
 * @requires $ItxUtilsFct
 * @requires common.service:ItxConfigurationSvc
 * @requires common.service:ItxLoginSvc
 *
 * @description
 * Wishlist service
 * Manage the wishlist logic to add, remove and list products from the wishlist.
 * 
 */
(function() {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxWishlistSvc', ItxWishlistSvc);

    ItxWishlistSvc.$inject = [  '$q',
                                'ItxUtilsFct',
                                'ItxConfigurationSvc',
                                'ItxLoginSvc',
                                'imWishlistService',
                                'ngDialog',
                                'ItxTranslateSvc'
    ];


    function ItxWishlistSvc(    $q,
                                ItxUtilsFct,
                                ItxConfigurationSvc,
                                ItxLoginSvc,
                                imWishlistService,
                                ngDialog,
                                ItxTranslateSvc) {
        var _this = this;

        // Elements added to the wishlist
        _this.wishlistElements = [];
        // Wishlist Modal
        _this.isVisibleMiniWishlist = false;
        //Cache for product info
        _this.productMap = {};

        /**
         * @property
         * @name active
         * @propertyOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Active property
         */
        //_this.config = ItxConfigurationSvc.getWishlistConfiguration();
        
        //var active = _this.config.enabled;
        var active = false;
        if(active){
            $('body').addClass('has-wishlist');
        }

        // We are going to use a single wishlist per user.
        _this.wishlistDefaultName = 'default';

        // Flags
        _this.loading = false;
        _this.loaded = false;

        var init = _load();

        // Service interface.
        var service = {
            promiseResolved: init,
            isActive: active,
            addProduct: _addProduct,
            removeProduct: _removeProduct,
            getItemsQuantity: _getItemsQuantity,
            getWishlist: _getWishlist,
            getWishlistPrice: _getWishlistPrice,
            isProductSelected: _isProductSelected,
            reloadWishlist: _reloadWishlist,
            updateWishlistName: _updateWishlistName,
            deleteWishlist: deleteWishlist,
            toggleMiniWishlist: toggleMiniWishlist,
            isVisibleMiniWishlist: isVisibleMiniWishlist
        };

        return service;

        /**
         * @ngdoc method
         * @constructor
         * @name _load
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * 
         * Check first if wishlist is active through configuration service.
         * Check if user is logged.
         * If wishlist array already has information, resolve with the data.
         * Make request to API and then resolve the promise.
         * @returns {promise} wishlist - Wishlist products
         */
        function _load() {
            
            var deferred = $q.defer();

            if (!active || !ItxLoginSvc.isLogged()) {
                deferred.resolve([]);
                return deferred.promise;
            }

            //If we have wishlist loaded, then resolve.
            if (_this.loaded) {
                deferred.resolve(_this.wishlistElements);
                return deferred.promise;
            }
            
            // deleteWishlist();

            inditex.wishlist.getByIndex(0, function(status, data) {

                if (status == 1) {

                    if (data && data.items) {

                        _setWishlist(data.items).then(function() {
                            deferred.resolve(_this.wishlistElements);
                        });
                    }
                    else {
                        deferred.resolve();
                    }
                }
                else {
                    deferred.reject(false);
                }
                // } else {
                //     //NO WISHLIST..
                    
                //     inditex.wishlist.create(_this.wishlistDefaultName,null, function(status) {
                //         if (status == 1) {
                //             deferred.resolve(_this.wishlistElements);
                //         } else {
                //             //NO RECIBIMOS LA WISHLIST....
                //             active = false;
                //             deferred.reject(false);
                //         }
                //     });
                // }
            });

            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @private
         * @name _setWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Set the local wishlist with items from API.
         * @param {array} items - Wishlist products
         * @returns {promise} promise
         */
        function _setWishlist(items) {

            var deferred = $q.defer();
            
            var promises = [];

            //We generate the product object for caché
            // _.each(items,function(item){
            //     var product = new Product(item.product); //jshint ignore:line
            //     product.fetched = true;
            //     _this.productMap[''+product.id] = product;
            // });

            _this.wishlistElements = items;

            if (inditex.iPage === 'ItxShopCartPage') {
                deferred.resolve(_this.wishlistElements);
                return deferred.promise;
            }

            _.forEach(_this.wishlistElements, function(item) {
            
                if(_this.productMap[''+item.productId] && inditex.iPage !== 'ItxMyAccountPage' ){
                    promises.push(joyr.Promise.resolved({product:_this.productMap[''+item.productId]}));
                }
                else {
                    promises.push(new joyr.catalog.Product(item.productId));
                }
                
            });

            if(promises.length<1){
                deferred.resolve();
                return deferred.promise;
            }

            joyr.Promise.all(promises)
                .done(function(results) {
                    angular.forEach(results, function(result) {
                        for (var i = 0; i < _this.wishlistElements.length; i++) {
                            
                            if (_this.wishlistElements[i].productId == result.product.id &&
                                (_this.wishlistElements[i].product && !_this.wishlistElements[i].product.state) ||
                                (!_this.wishlistElements[i].product)) {
                            _this.wishlistElements[i].product = _completeProduct(result.product, _this.wishlistElements[i].catentryId);
                                break;
                            }
                        }
                    });

                    deferred.resolve(_this.wishlistElements);
                });
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @private
         * @name _completeProduct
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Complete product information adding image URL and price to each product of the wishlist.
         * @param {array} products - Wishlist products
         * @returns {array} products - Wishlist products
         */
        function _completeProduct(product, sku) {
            var colorId;
            var colors = product.activeDetail.colors;
            var sizes;
            product.state = {};
            for (var color = 0; color < colors.length; color++) {
                sizes = colors[color].sizes;
                colorId = colors[color].id;
                for (var sizeIndex = 0; sizeIndex < sizes.length; sizeIndex++) {
                    if (sizes[sizeIndex].sku == sku) {
                        var imgs = ItxUtilsFct.getImageProductUrls(product.activeDetail, colorId, 'checkout', 'main', 'product');
                        product.state.selectedColor = colors[color];
                        product.state.selectedSize = sizes[sizeIndex];
                        product.colorId = colorId;
                        product.imageToShow = imgs[0];
                        product.sizeName = (sizes[sizeIndex].name === '01') ? ItxTranslateSvc.translateCms('legacy.one_size') : ItxTranslateSvc.translateCms('legacy.ItxShopCartPage.sizeMin') + ' ' + sizes[sizeIndex].name;
                        return product;
                    }
                }
            }

            return product;
        }
        /**
         * @ngdoc method
         * @name toggleMiniWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Toggle the miniwishlist menu
        */
        function toggleMiniWishlist() {
            if (_this.isVisibleMiniWishlist) {
                _this.isVisibleMiniWishlist = false;
                // ItxHeaderFct.hideWishlist();
            } else {
                _this.isVisibleMiniWishlist = true;
                // ItxHeaderFct.showWishlist();
            }
        }
         /**
         * @ngdoc method
         * @name isVisibleMiniWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Return if the miniwishlist is opened.
         * @returns {boolean} isVisibleMiniWishlist
         */
        function isVisibleMiniWishlist(){
            return _this.isVisibleMiniWishlist;
        }

        /**
         * @ngdoc method
         * @name _addProduct
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Add product to the wishlist.
         * @param {number} sku - sku item number
         * @param {object} product - product object.
         * @returns {promise | boolean} productAdded to the wishlist
         */
        function _addProduct(sku, product) {

            var deferred = $q.defer();

            if(_getItemsQuantity() +1 > _this.config.maxItems){
                ngDialog.open({
                    template: 'ItxWishlistMaxItemsDialog.html',
                    className: 'ngdialog-theme-plain',
                    showClose: true,
                    data: {
                        text: {  message: ItxTranslateSvc.translateCms('legacy.ItxWishlist.maxItems'),
                                 title: 'Error'
                        }
                    }
                });
                deferred.reject(false);
                return deferred.promise;
            }
            var obj = {
                'catentryId': sku,
                'quantity': 1,
                'productId': product.id
            };
            inditex.wishlist.create(_this.wishlistDefaultName, obj, function(status, wishlist) {
                if (status == 1) {
                    _setWishlist(wishlist.items).then(function() {
                        deferred.resolve(_this.wishlistElements);
                    });
                    imWishlistService.createEventAddToWishlist(product);
                } else {
                    deferred.reject(false);
                }
            });
            
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name _removeProduct
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Remove product from wishlist.
         * @param {object} sku - SKU number
         * @param {object} product - product object.
         * @returns {promise | boolean} product removed from the wishlist
         */
        function _removeProduct(catentryId, product) {

            var deferred = $q.defer();

            inditex.wishlist.remove(0, catentryId, function(status, wishlist) {
                if (status == 1) {
                    _setWishlist(wishlist.items).then(function() {
                        deferred.resolve(_this.wishlistElements);
                    });
                    imWishlistService.createEventRemoveFromWishlist(product);
                } else {
                    deferred.reject(false);
                }
            });

            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name _getWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Get the current wishlist.
         * @returns {array} wishlist - wishlist items
         */
        function _getWishlist() {
            return _this.wishlistElements;
        }
        /**
         * @ngdoc method
         * @name _getWishlistPrice
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Get the current total price of the wishlist
         * @returns {number} price - wishlist price
         */
        function _getWishlistPrice() {
            var prods = _this.wishlistElements;
            //Sumamos precios de producto
            var total = _.reduce(prods, function(acum, product) {
                return acum + product.unitPrice;
            }, 0);
            return inditex.formatPrice(total);
        }
        /**
         * @ngdoc method
         * @name _getItemsQuantity
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Get amount of items added to the wishlist.
         * @returns {number} quantity - Number of items.
         */
        function _getItemsQuantity() {
            return _this.wishlistElements.length;
        }
        /**
         * @ngdoc method
         * @name _reloadWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Reload wishlist after user signed in to update the quantity of items to show under the star in the header.
         */
        function _reloadWishlist() {
            _this.loaded = false;
            _load();
        }
        /**
         * @ngdoc method
         * @name updateWishlistName
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Update the wishlist name to new one.
         * @param {string} newName - New wishlist name.
         */
        function _updateWishlistName(newName) {
            inditex.wishlist.updateName(0, newName, function() {});
        }
        /**
         * @ngdoc method
         * @name deleteWishlist
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Delete the user wishlist.
         * @returns {promise} boolean - Wishlist deleted
         */
        function deleteWishlist() {
            var deferred = $q.defer();

            inditex.wishlist._wishlists = [];

            inditex.wishlist._save(inditex.wishlist._wishlists, function(status) {
                if (status === 1) {
                    _this.wishlistElements = [];
                    deferred.resolve(true);
                } else {
                    deferred.reject(false);
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name _isProductSelected
         * @methodOf  common.wishlist.service:ItxWishlistSvc
         * @description
         * Check if given product exists in the wishlist.
         * @returns {boolean} selected - Product selected
         */
        function _isProductSelected(sizes, sku) {
            
            for (var wishlistItem = 0; wishlistItem < _this.wishlistElements.length; wishlistItem++) {

                var item = _this.wishlistElements[wishlistItem];

                if (sku && item.catentryId == sku) {
                    return true;
                }

                for (var i = 0; i < sizes.length; i++) {
                    if (sizes[i].sku == item.catentryId) {
                        return sizes[i].sku;
                    }
                }
            }

            return false;
        }

    }

})(window.itxApp);